import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { FieldTypesEnum, formBundleReadinessStatusOptions } from 'constants/loanActionEditor';

import { DynamicValueInput } from '../LoanActionItems';

import { wrapperStyles } from './LoanActionReadinessStatusRow.styles';

const emptyOptions = [];

const LoanActionReadinessStatusRow = ({
  index,
  rootPath,
  isDisabled = false,
  isEditAllowed,
  formBundlesOptions = emptyOptions,
}) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <Box sx={wrapperStyles}>
      <DynamicValueInput
        required
        className="grow"
        disabled={isDisabled || !isEditAllowed}
        label="Readiness Status"
        name={`${fieldPath}.readinessStatus`}
        options={formBundleReadinessStatusOptions}
        type={FieldTypesEnum.SELECT}
      />
      <DynamicValueInput
        className="grow"
        disabled={isDisabled || !isEditAllowed}
        label="Form Bundles"
        name={`${fieldPath}.formBundleIds`}
        options={formBundlesOptions}
        type={FieldTypesEnum.MULTISELECT}
      />
    </Box>
  );
};

LoanActionReadinessStatusRow.propTypes = {
  index: PropTypes.number.isRequired,
  rootPath: PropTypes.string.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  formBundlesOptions: PropTypes.array,
};

export default memo(LoanActionReadinessStatusRow);
